<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="blendReceivalForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                blendReceivalForm: () => import('../forms/BlendReceivalForm'),
                headers: [
                    { text: 'Blend', value: 'blendId', table: 'blends', form: () => import('../forms/BlendForm') },
                    { text: 'Blend Supplier', value: 'blendSupplierId', table: 'blendSuppliers', form: () => import('../forms/BlendSupplierForm') },
                    { text: 'Received On', value: 'receivedOn', format: this.formatDate },
                    { text: 'Price', value: 'price' },
                    { text: 'Delivery Company', value: 'deliveryCompany' },
                    { text: 'Checked By Staff Member', value: 'checkedByStaffMemberId', table: 'staffMembers', form: () => import('../forms/StaffMemberForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    blends: [],
                    blendSuppliers: [],
                    staffMembers: [],
                    items: []
                },
                sorting: [
                    { column: "receivedOn", direction: "descending" },
                    { column: "deliveryCompany", direction: "ascending" },
                    { column: "blendId", direction: "ascending" },
                    { column: "blendSupplierId", direction: "ascending" },
                ],
                itemsField: 'blendReceivals',
                editPageName: 'blendReceival',
                apiMethod: 'BlendReceivals',
                claimName: 'BlendReceivals',
                formTitle: 'Blend Receival',
                excelTitle: 'Blend Receivals',
                hasEditPage: false,
            }
        },
    };
</script>
